module.exports = __webpack_public_path__ + "img/our-team-img-1.f727f8a6.png";